import {  useEffect  } from 'react'
import PropTypes from 'prop-types'
import { connect, } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as authActions from 'action/auth'
import { translate } from 'react-i18next'
import { push } from 'react-router-redux'

const PingAuthLogin = (props) => {
  PingAuthLogin.propTypes = {
    getUserInfo: PropTypes.func.isRequired
  }


  const { getUserInfo, dispatch } = props
  // const error = {
  //  dsMessage: "",
  //  message: {
  //    dsMessage: "Login expired due to inactivity."
  //  },
  //  cdStatus: 400
  // }
  
  const redirectToHome = () => {
  // dispatch(loginError(error))
    dispatch(push('/login'))
  }
  useEffect(() => {
      const token = new URLSearchParams(window.location.search).get('token')
      getUserInfo(token, redirectToHome)
  }, [])

  return null
}

const mapStateToProps = ({ auth }) => ({
  error: auth.error
})
/**
 * Maps actions and dispatch them to props
 * @param {Function} dispatch
 * @return {Object} props
 */
const mapDispatchToProps = (dispatch) =>
  bindActionCreators(authActions, dispatch)
/* istanbul ignore next */
const PingAuthLoginTranslated = translate(null, {
  wait: true,
  translateFuncName: 'translate',
})(PingAuthLogin)

export default connect(mapStateToProps, mapDispatchToProps)(PingAuthLoginTranslated)

export { PingAuthLogin }
